import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalculateService {

  constructor(private http: HttpClient) {
  }

  calculateTaxLite(body: any): Observable<any> {
    return this.http.post(`${ environment.apiBaseUrl }/lite`, {
      ...body
    });
  }

  createVatLog(body: any): Observable<any> {
    return this.http.post(`${ environment.apiBaseUrl }/vat`, {
      ...body
    });
  }
}
